/*
 * Cleverroute
 * Cleverroute API
 *
 * OpenAPI spec version: 0.0.2
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.36
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {MetricParamsCo2} from './MetricParamsCo2';
import {MetricParamsCost} from './MetricParamsCost';
import {MetricParamsSport} from './MetricParamsSport';
import {MetricParamsTime} from './MetricParamsTime';

/**
 * The MetricParams model module.
 * @module model/MetricParams
 * @version 0.0.2
 */
export class MetricParams {
  /**
   * Constructs a new <code>MetricParams</code>.
   * @alias module:model/MetricParams
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>MetricParams</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/MetricParams} obj Optional instance to populate.
   * @return {module:model/MetricParams} The populated <code>MetricParams</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new MetricParams();
      if (data.hasOwnProperty('co2'))
        obj.co2 = MetricParamsCo2.constructFromObject(data['co2']);
      if (data.hasOwnProperty('cost'))
        obj.cost = MetricParamsCost.constructFromObject(data['cost']);
      if (data.hasOwnProperty('sport'))
        obj.sport = MetricParamsSport.constructFromObject(data['sport']);
      if (data.hasOwnProperty('time'))
        obj.time = MetricParamsTime.constructFromObject(data['time']);
    }
    return obj;
  }
}

/**
 * @member {module:model/MetricParamsCo2} co2
 */
MetricParams.prototype.co2 = undefined;

/**
 * @member {module:model/MetricParamsCost} cost
 */
MetricParams.prototype.cost = undefined;

/**
 * @member {module:model/MetricParamsSport} sport
 */
MetricParams.prototype.sport = undefined;

/**
 * @member {module:model/MetricParamsTime} time
 */
MetricParams.prototype.time = undefined;

